import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, resolveAssetUrl } from "../lib/api";
import YouTubePlayer from "../components/YouTubePlayer";
import WhatsAppFloat from "../components/WhatsAppFloat";

const StudentVideo = () => {
  const { slug } = useParams();
  const [video, setVideo] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Add noindex meta tag
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "robots";
      document.head.appendChild(meta);
    }
    meta.content = "noindex, nofollow";
    return () => {
      if (meta) meta.content = "index, follow";
    };
  }, []);

  useEffect(() => {
    setLoading(true);
    setError(null);
    api
      .get(`/videos/${encodeURIComponent(slug)}`)
      .then(({ data }) => setVideo(data))
      .catch((e) => setError(e?.response?.status === 404 ? "not_found" : "error"))
      .finally(() => setLoading(false));
  }, [slug]);

  useEffect(() => {
    if (video?.name) document.title = `${video.name} - ActiveEnglish`;
  }, [video]);

  return (
    <div style={{ minHeight: "100vh", background: "#F4F1EA", padding: "24px" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <a
          href="/"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            textDecoration: "none",
            marginBottom: 22,
          }}
        >
          <span
            style={{
              width: 34,
              height: 34,
              borderRadius: 10,
              background: "linear-gradient(135deg,#5446EA,#C04ABF)",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontWeight: 800,
              fontSize: 16,
            }}
          >
            AE
          </span>
          <span style={{ color: "#1A1352", fontWeight: 800, fontSize: 18 }}>
            Active<span style={{ color: "#5446EA" }}>English</span>
          </span>
        </a>

        {loading && (
          <div style={{ padding: 80, textAlign: "center", color: "#5F5A72" }}>Cargando video…</div>
        )}

        {error === "not_found" && (
          <div
            style={{
              padding: "60px 32px",
              background: "#fff",
              borderRadius: 24,
              textAlign: "center",
              boxShadow: "0 20px 50px -25px rgba(26,19,82,0.2)",
            }}
          >
            <h1 style={{ color: "#1A1352", margin: "0 0 12px", fontSize: 28 }}>Video no disponible</h1>
            <p style={{ color: "#5F5A72", margin: 0 }}>
              Este enlace ya no está activo. Si crees que es un error, contacta con tu tutor.
            </p>
          </div>
        )}

        {error === "error" && (
          <div style={{ padding: 60, textAlign: "center", color: "#E83E0A" }}>
            Ocurrió un error al cargar el video. Intenta nuevamente.
          </div>
        )}

        {video && (
          <>
            <h1
              className="h-display"
              style={{ color: "#1A1352", fontSize: "clamp(28px,3.6vw,42px)", margin: "0 0 22px" }}
            >
              {video.name}
            </h1>
            <YouTubePlayer videoId={video.youtube_id} title={video.name} />
            <p style={{ color: "#5F5A72", fontSize: 13, marginTop: 18 }}>
              Contenido exclusivo para alumnos de ActiveEnglish.
            </p>
          </>
        )}
      </div>
      <WhatsAppFloat />
    </div>
  );
};

export default StudentVideo;
